import fetch from "../fetch";

export default ({ values, propertyId }) => {
  return fetch({
    path: propertyId ? `/re/prop-masters/${propertyId}` : "/re/prop-masters",
    method: propertyId ? "PUT" : "POST",
    data: values,
  });
};
